import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { format, parseISO } from "date-fns";
import {
  danger,
  success,
  showLoading,
} from "../../../components/show-notification";
import api from "../../../providers/api";
import LoadingPanel from "../../../components/loading-painel";
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Layout from "../../../layout";
import validateCadastrar from "./form-validate-cadastrar";
import validateEditar from "./form-validate-editar";

const NovidadeCadastrar = () => {
  const location = useLocation();
  const history = useHistory();
  const [state, setState] = useState({
    id: 0,
    titulo: "",
    descricao: "",
    titulo_in: "",
    descricao_in: "",
    titulo_es: "",
    descricao_es: "",
    data: "",
    imagem: "",
  });

  let preencherValoresEdits = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const enviarFormulario = async (e) => {
    e.preventDefault();

    if (!window.$("#form-novidade").valid()) {
      return;
    }

    try {
      const formData = new FormData();

      var code = window.$("#summernote").summernote("code");
      var code_es = window.$("#summernote_es").summernote("code");
      var code_in = window.$("#summernote_in").summernote("code");

      code = '<p><br></p>' + code + '<p>                                                                    </p>';
      code_es = '<p><br></p>' + code_es + '<p>                                                                    </p>';
      code_in = '<p><br></p>' + code_in + '<p>                                                                    </p>';

      formData.append("id", state.id);
      formData.append("data", state.data);
      formData.append("imagem", state.imagem);

      formData.append("titulo", state.titulo);
      formData.append("descricao", code);

      formData.append("titulo_in", state.titulo_in);
      formData.append("descricao_in", code_in);

      formData.append("titulo_es", state.titulo_es);
      formData.append("descricao_es", code_es);

      const enviar = state.id > 0 ? api.put : api.post;

      const requisicao = await enviar("/novidade", formData);

      const { data } = requisicao;

      if (!data.status) {
        danger(data.mensagem);
        return;
      }

      if (!data.data) {
        return;
      }

      success(data.mensagem);
      history.push("/novidade");
    } catch (error) {
      console.log(error);
      danger("Erro ao cadastrar a novidade.");
    }
  };

  useEffect(() => {
    window.$("#summernote").summernote({
      height: window.innerHeight - window.innerHeight / 3
    });
    window.$("#summernote_in").summernote({
      height: window.innerHeight - window.innerHeight / 3
    });
    window.$("#summernote_es").summernote({
      height: window.innerHeight - window.innerHeight / 3
    });
  }, []);

  useEffect(() => {
    const carregarDados = async () => {
      if (!location.state) {
        return;
      }

      try {
        showLoading(".ibox-content");

        const requisicao = await api.get(`/novidade/${location.state.id}`);

        const { data } = requisicao;

        if (!data.status) {
          danger(data.mensagem);
          return;
        }

        if (!data.data) {
          return;
        }

        data.data.data = data.data.data_iso;

        setState(data.data);
        window.$("#summernote").summernote("code", data.data.descricao);
        window.$("#summernote_in").summernote("code", data.data.descricao_in);
        window.$("#summernote_es").summernote("code", data.data.descricao_es);
        showLoading(".ibox-content");
      } catch (error) {
        console.log(error);
        showLoading(".ibox-content");
        danger("Erro ao carregar os dados da novidade");
      }
    };

    let validacao = window
      .$("#form-novidade")
      .validate(!location.state ? validateCadastrar : validateEditar);

    carregarDados();

    return () => validacao.destroy();
  }, [location.state]);

  return (
    <>
      <Layout
        titulo="Ibraflex - Novidades"
        header="Cadastro da Novidade"
        action={{ titulo: "Voltar", link: "/novidade" }}
      >
    
        <div className="ibox-content">
            <LoadingPanel />
            <div className="row">
                <div className="col-lg-12">
               
                        <div className="ibox ">
                            <div className="ibox-title">
                                <h5>Dados da novidade</h5>
                            </div>
                            <div className="ibox-content">
                                <LoadingPanel />
                                <div className="row">
                                <div className="col-lg-12">
                                    <form id="form-novidade">
                                        <div className="row">
                                            <div className="col-lg-8">
                                            <div className="form-group">
                                                <label>Imagem da novidade</label>
                                                <input
                                                type="file"
                                                placeholder="Imagem da novidade"
                                                className="form-control"
                                                name="imagem"
                                                accept="image/*"
                                                onChange={(e) =>
                                                    setState({
                                                    ...state,
                                                    imagem: e.target.files[0],
                                                    })
                                                }
                                                />
                                            </div>
                                            </div>

                                            <div className="col-lg-4">
                                            <div className="form-group">
                                                <label>Data da novidade</label>
                                                <input
                                                type="datetime-local"
                                                placeholder="Data da novidade"
                                                className="form-control"
                                                name="data"
                                                value={state.data}
                                                onChange={(e) => preencherValoresEdits(e)}
                                                />
                                            </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                            <div className="form-group">
                                                <div class="tabs-container">
                                                <ul class="nav nav-tabs" role="tablist">
                                                    <li>
                                                    <a
                                                        class="nav-link active"
                                                        data-toggle="tab"
                                                        href="#tab-1"
                                                    >
                                                        Português
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        class="nav-link"
                                                        data-toggle="tab"
                                                        href="#tab-2"
                                                    >
                                                        Inglês
                                                    </a>
                                                    </li>
                                                    <li>
                                                    <a
                                                        class="nav-link"
                                                        data-toggle="tab"
                                                        href="#tab-3"
                                                    >
                                                        Espanhol
                                                    </a>
                                                    </li>
                                                </ul>
                                                <div class="tab-content">
                                                    <div
                                                    role="tabpanel"
                                                    id="tab-1"
                                                    class="tab-pane active"
                                                    >
                                                    <div class="panel-body">
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Título da novidade</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Título da novidade"
                                                                className="form-control"
                                                                name="titulo"
                                                                value={state.titulo}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Descrição da novidade</label>
                                                            <textarea
                                                              className="form-control"
                                                              id="summernote"
                                                              name="descricao"
                                                              placeholder="Descrição da novidade."
                                                              rows="5"
                                                              value={state.descricao}
                                                              onChange={(e) => preencherValoresEdits(e)}
                                                            />
                                                          </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div
                                                    role="tabpanel"
                                                    id="tab-2"
                                                    class="tab-pane"
                                                    >
                                                    <div class="panel-body">
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Título da novidade</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Título da novidade"
                                                                className="form-control"
                                                                name="titulo_in"
                                                                value={state.titulo_in}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Descrição da novidade</label>
                                                            <textarea
                                                              className="form-control"
                                                              id="summernote_in"
                                                              name="descricao_in"
                                                              placeholder="Descrição da novidade em ingles"
                                                              rows="5"
                                                              value={state.descricao_in}
                                                              onChange={(e) => preencherValoresEdits(e)}
                                                            />
                                                            
                                                            
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div
                                                    role="tabpanel"
                                                    id="tab-3"
                                                    class="tab-pane"
                                                    >
                                                    <div class="panel-body">
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Título da novidade</label>
                                                            <input
                                                                type="text"
                                                                placeholder="Título da novidade"
                                                                className="form-control"
                                                                name="titulo_es"
                                                                value={state.titulo_es}
                                                                onChange={(e) =>
                                                                preencherValoresEdits(e)
                                                                }
                                                            />
                                                            </div>
                                                        </div>
                                                        </div>
                                                        <div className="row">
                                                        <div className="col-lg-12">
                                                            <div className="form-group">
                                                            <label>Descrição da novidade</label>
                                                            
                                                            <textarea
                                                              className="form-control"
                                                              id="summernote_es"
                                                              name="descricao_es"
                                                              placeholder="Descrição da novidade em espanhol"
                                                              rows="5"
                                                              value={state.descricao_es}
                                                              onChange={(e) => preencherValoresEdits(e)}
                                                            />                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    </div>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        <div>
                                            <button
                                            className="btn btn-sm btn-success float-right m-t-n-xs"
                                            type="submit"
                                            onClick={(e) => enviarFormulario(e)}
                                            >
                                            <strong>Salvar</strong>
                                            </button>
                                        </div>
                                    </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                
                </div>
            </div>
        </div>
            
      </Layout>
    </>
  );
};

export default NovidadeCadastrar;
